<template>
  <div v-loading="waitLoading">
    <myHeader :num="replyNum" :isShow="isShow" @openList="openList"></myHeader>
    <div class="kbxmList">
      <div>
        <div class="searchBox">
          <button
            type="button"
            :class="xmlx == 1 ? 'active' : ''"
            @click="getList(1)"
          >
            今日开标项目
          </button>
          <button
            type="button"
            :class="xmlx == 2 ? 'active' : ''"
            @click="getList(2)"
          >
            全部项目
          </button>
          <el-input
            placeholder="关键字搜索"
            v-model="searchText"
            @keyup.enter.native="searchData"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="searchData"
            ></i>
          </el-input>
        </div>
        <ul class="xmLists">
          <!-- zt 0:待开标;-1,1:正在开标;2:开标结束;3:开标中止;4:二次开标 正在开标;5:二次开标评标结束正在开标; -->
          <li
            v-for="(item, index) in xmList"
            :key="index"
            :class="{
              active:
                item.zt == -1 || item.zt == 1 || item.zt == 4 || item.zt == 5,
              wait: item.zt == 0,
              over: item.zt == 2,
              zz: item.zt == 3,
            }"
            @click="goKb(item)"
          >
            <div class="lf">
              <h3>{{ item.xmmc }}</h3>
              <p>
                标段编号<span>{{ item.bdbh }}</span
                >开标时间<span>{{ item.kbsj }}</span
                >项目类型<span>{{ item.xmdlxsz }}</span>
              </p>
            </div>
          </li>
        </ul>
        <p class="noList" v-show="flag">
          <template v-if="xmlx == 2">
            {{ noText ? "无开标项目" : "无法找到您搜索的内容" }}</template
          >
          <template v-if="xmlx == 1">{{
            noText ? "今日无开标项目" : "无法找到您搜索的内容"
          }}</template>
        </p>
        <myPage
          v-if="xmlx == 2"
          :total="total"
          :page-size="pageSize"
          :currentPage="currentPage"
          @changePage="changePage"
        ></myPage>
      </div>
    </div>
    <el-dialog
      class="dialogVisible"
      width="80%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="buttonActive = 0"
    >
      <div>
        <p class="xie">
          <button
            :class="buttonActive == 0 ? 'buttonChecked' : ''"
            @click="todayHistory(0)"
          >
            <span>今日询标</span>
          </button>
          <button
            :class="buttonActive == 1 ? 'buttonChecked' : ''"
            @click="todayHistory(1)"
          >
            <span>历史询标</span>
          </button>
        </p>
        <div class="table">
          <table-tem
            :config="tableConfig"
            @tableBtn="tableBtn"
            @changePage="tableChangePage"
            @changePages="changePages"
          >
            <template v-slot:replyDeadline="{ data }">
              <span style="color: red">{{ data.replyDeadline }}</span>
            </template>
          </table-tem>
          <b
            >注：请在30分钟内进行回复，否则将视为放弃回复。若有疑问，请及时联系代理公司。</b
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="dialogVisible"
      :visible.sync="dialogVisibleLook"
      width="70%"
      :close-on-click-modal="false"
      @close="back"
    >
      <div>
        <p class="xie">
          <button><span>今日询标</span></button>
        </p>
        <div class="dialogTitlt">
          <p>评标委员会询标表</p>
          <div style="overflow: hidden">
            <div v-if="dateDifference >= 0">
              <p
                v-if="
                  bidRecord.status == 1 ||
                  bidRecord.status == 2 ||
                  bidRecord.status == 4
                "
                class="stauts whf"
              >
                回复倒计时 <span class="djs">{{ computationTime }}</span>
              </p>
            </div>
            <div v-if="bidRecord.status == 3" class="stauts cswhf"></div>
            <div v-if="bidRecord.status == 5" class="stauts yhf"></div>
          </div>
        </div>
        <table class="bg-info">
          <tr>
            <td style="width: 140px">项目名称</td>
            <td>{{ bidInquiryDetails.projectName }}</td>
            <td style="width: 140px">招标编号</td>
            <td>{{ bidInquiryDetails.projectNo }}</td>
          </tr>
          <tr>
            <td>招标人</td>
            <td>{{ bidInquiryDetails.tenderee }}</td>
            <td>招标代理</td>
            <td>{{ bidInquiryDetails.tenderingAgency }}</td>
          </tr>
          <tr>
            <td>评标日期</td>
            <td>{{ bidInquiryDetails.createTime }}</td>
            <td>评标地点</td>
            <td>{{ bidInquiryDetails.evaluationAddr }}</td>
          </tr>
          <tr>
            <td>询标对象(投标人)</td>
            <td colspan="3">{{ bidInquiryDetails.bidDepartment }}</td>
          </tr>
          <tr>
            <td colspan="4">
              <p style="text-align: center; line-height: 40px">询标内容</p>
              <div>{{ bidInquiryDetails.content }}</div>
              <p class="time">时间：{{ bidInquiryDetails.bidInquiryTime }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="4" style="text-align: center">
              回复内容（包括所补充的证明材料目录）
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <textarea
                v-if="bidRecord.status == 1"
                style="width: 100%"
                id="replyContent"
                maxlength="600"
                v-model="bidInquiryDetails.replyContent"
              ></textarea>
              <div v-if="bidRecord.status != 1">
                {{ bidInquiryDetails.replyContent }}
              </div>
              <div style="line-height: 40px; padding-left: 40px">
                <span style="position: relative; top: 38px"
                  >投标人（签章）</span
                >
                <p class="rt time">
                  时间:
                  <b v-if="bidRecord.status == 1"
                    ><i></i>年<i></i>月<i></i>日<i></i>时<i></i>分</b
                  >
                  <b v-else> {{ bidInquiryDetails.replyTime }}</b>
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4" style="text-align: center">评标委员会审核意见</td>
          </tr>
          <tr>
            <td colspan="4">
              <p style="margin-top: 100px">
                <span style="margin-right: 100px; margin-left: 40px"
                  >组长（签名）：</span
                >
                <span>评标委员（签名）：</span>
              </p>
              <p class="time">
                时间：<i></i>年<i></i>月<i></i>日<i></i>时<i></i>分
              </p>
            </td>
          </tr>
          <tr>
            <td>备注</td>
            <td colspan="3"></td>
          </tr>
        </table>
        <div class="red" style="line-height: 24px; margin-top: 5px">
          <p>注：投标企业回复时间以发送时间为准</p>
        </div>
        <div class="btnBox" style="text-align: center">
          <el-button
            v-if="bidRecord.status == 1 && dateDifference >= 0"
            class="btn btn-true"
            type="primary"
            @click="save()"
            >回复</el-button
          >
          <el-button
            v-if="bidRecord.status == 2 && dateDifference >= 0"
            class="btn btn-true"
            type="primary"
            @click="createPdf()"
            >生成pdf</el-button
          >
          <el-button
            v-if="bidRecord.status == 4 && dateDifference >= 0"
            class="btn btn-true"
            type="primary"
            @click="goSign()"
            >去签章</el-button
          >
          <el-button class="btn btn-false" type="button" @click="back()"
            >返回</el-button
          >
        </div>
      </div>
    </el-dialog>
    <template v-if="isShowSureQzDialog">
      <div class="atOnceOpen">
        <el-dialog
          title="签章"
          :visible.sync="isShowSureQzDialog"
          lock-scroll
          :close-on-click-modal="false"
        >
          <div class="button-wrapper">
            <span class="qz-text">正在签章中</span>
            <button type="primary" @click="sureQz" class="sure-qz">
              确认签章
            </button>
          </div>
        </el-dialog>
      </div>
    </template>
  </div>
</template>
<script>
import tableTem from "@/components/tableTem/index.vue";
import myPage from "../components/page";
import myHeader from "../components/header";
export default {
  name: "kbxmList",
  components: {
    myPage,
    myHeader,
    tableTem,
  },
  data() {
    return {
      xmlx: 1,
      searchText: "",
      xmList: [],
      total: 1,
      currentPage: 1,
      pageSize: 5,
      flag: false,
      noText: true,
      waitLoading: false,
      dialogVisible: false,
      dialogVisibleLook: false,
      buttonActive: 0,
      tableConfig: {
        head: [
          {
            type: "index",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "projectName",
            title: "询标项目",
            align: "center",
          },
          {
            key: "bidInquiryTime",
            title: "询标时间",
            align: "center",
          },
          {
            title: "回复截止时间",
            align: "center",
            type: "slot",
            slotName: "replyDeadline",
          },
          {
            key: "recoveryTime",
            title: "回复时间",
            align: "center",
          },
          {
            key: "status",
            title: "状态",
            align: "center",
            showTool: true,
            codeMateVal: {
              1: "未回复",
              2: "已回复",
              3: "超时未回复",
              4: "生成pdf",
              5: "已签章",
            },
          },
          {
            title: "操作",
            align: "center",
            btns: [
              {
                type: "text",
                name: "回复",
                color: "#FFF",
                flag: "Reply",
                show: { status: [1] },
              },
              {
                type: "text",
                color: "#FFF",
                name: "查看详情",
                flag: "Look",
                hidden: { status: [1] },
              },
            ],
          },
        ],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
      },
      replyNum: 0,
      bidInquiryDetails: {},
      bidRecord: {},
      recordRow: {}, // 每行的row
      dateDifference: 0,
      timeInterval: null,
      dialogVisibleSign: false,
      pdfInfo: {}, // pdf的信息

      tabIndex: 0,
      isShowSureQzDialog: false,
      hadQz: false,
    };
  },
  computed: {
    isShow() {
      return localStorage.getItem("role") == "B";
    },
    computationTime() {
      // ms
      // this.dateDifference < 1000 * 60 * 60
      let m = parseInt(this.dateDifference / 1000 / 60);
      m = m < 10 ? "0" + m : m;
      let s = parseInt((this.dateDifference / 1000) % 60);
      s = s < 10 ? "0" + s : s;
      return m + "分" + s + "秒";
    },
  },
  methods: {
    async sureQz() {
      // 确认签章弹窗
      let para = {
        recordId: this.recordRow.id,
      };
      this.$api
        .inquiryDetails(para)
        .then((res) => {
          if (res?.data?.meta?.success) {
            if (res?.data?.data?.bidRecord.status == 5) {
              this.hadQz = true;
              this.isShowSureQzDialog = false;
              this.bidRecord = res?.data?.data?.bidRecord;
              this.$message({
                message: "签章成功",
                type: "success",
              });
              this.dialogVisibleSign = false;
              this.back();
            } else {
              this.isShowSureQzDialog = true;
              this.$message({
                message: "签章正在进行中~",
                type: "warning",
              });
            }
          } else {
            this.isShowSureQzDialog = true;
            this.$message.error(res?.meta?.message || "请求失败，请稍后重试！");
          }
        })
        .catch((err) => {
          this.$message({
            message: err.data.message,
            type: "error",
          });
        });
    },
    getList(xmlx) {
      localStorage.removeItem("searchObj");
      this.xmlx = xmlx;
      this.currentPage = 1;
      this.searchText = "";
      this.getData();
    },
    searchData() {
      this.currentPage = 1;
      this.getData();
    },
    getData() {
      let para = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        mc: this.searchText,
        lx: this.xmlx,
        ryjs: localStorage.getItem("role") ? localStorage.getItem("role") : "",
      };
      this.waitLoading = true;
      this.flag = false;
      this.$api
        .getkbxmList(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.xmList = res.data.data.list;
            this.total = res.data.data.total;
            if (this.xmList.length == 0) {
              this.flag = true;
              if (!this.searchText) {
                this.noText = true;
              } else {
                this.noText = false;
              }
            }
          } else {
            this.$message({
              message: res.data.meta.message,
              type: "error",
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {
          this.waitLoading = false;
        });
    },
    //投标人进入项目前先判断接口
    //进入开标页面
    async goKb(obj) {
      // 同步项目状态到交易平台（进入项目前置流程）
      this.syncProjectState(obj);

      let flag = false;
      if (localStorage.getItem("role") == "B") {
        this.waitLoading = true;
        let para = {
          bdId: obj.bdId,
        };
        await this.$api
          .checkUploadBidFile(para)
          .then((res) => {
            if (res.data.meta.success) {
              if (!res.data.data) {
                this.$message({
                  message: "您未递交投标文件，无需进入该项目",
                  type: "error",
                });
                flag = false;
              } else {
                flag = true;
              }
            } else {
              this.$message({
                message: res.data.meta.message,
                type: "error",
              });
            }
            this.waitLoading = false;
          })
          .catch(() => {
            this.waitLoading = false;
          });
      } else {
        flag = true;
      }
      if (flag) {
        let searchObj = {
          xmlx: this.xmlx,
          currentPage: this.currentPage,
          searchText: this.searchText,
        };
        localStorage.setItem("searchObj", JSON.stringify(searchObj));
        if (obj.zt == "3") {
          localStorage.setItem("kbxmZt", "3");
        } else {
          localStorage.removeItem("kbxmZt");
        }
        localStorage.setItem("sxtLx", obj.zbcd);
        if (obj.zbxmkpfs == 7 || obj.zbxmkpfs == 10) {
          this.$router.push({
            path: "/bxxmlc",
            query: { bdId: obj.bdId, xmdl: obj.xmdl, from: 'list' },
          });
        } else {
          this.$router.push({
            path: "/xmlc",
            query: { bdId: obj.bdId, xmdl: obj.xmdl, from: 'list' },
          });
        }
      }
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    getReplyNum() {
      this.waitLoading = true;
      this.$api
        .replyNum()
        .then((res) => {
          if (res.data.meta.success) {
            this.replyNum = res.data.data;
          } else {
            this.$message({
              message: res.data.meta.message,
              type: "error",
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {
          this.waitLoading = false;
        });
    },
    // 询标
    openList() {
      this.dialogVisible = true;
      this.waitLoading = true;
      let para = {
        flag: this.buttonActive,
        pageNum: this.tableConfig.currentPage,
        pageSize: this.tableConfig.pageSize,
      };
      this.$api
        .inquiryRecord(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.tableConfig.data = res.data.data.bidInquiryRecord.list;
            this.tableConfig.total = res.data.data.bidInquiryRecord.total;
          } else {
            this.$message({
              message: res.data.meta.message,
              type: "error",
            });
          }
          this.waitLoading = false;
        })
        .catch((err) => {
          this.waitLoading = false;
          this.$message({
            message: err.data.message,
            type: "error",
          });
        });
    },
    todayHistory(num) {
      if (num) {
        this.buttonActive = 1;
      } else {
        this.buttonActive = 0;
      }
      this.openList();
    },
    save() {
      if (!this.bidInquiryDetails.replyContent) {
        this.$message.error("请先填写回复内容");
      } else {
        if (this.bidInquiryDetails.replyContent.length > 600) {
          this.$message.error("回复内容不能超过600字");
        } else {
          let para = {
            recordId: this.recordRow.id,
            detailsId: this.bidInquiryDetails.id,
            content: this.bidInquiryDetails.replyContent,
          };
          this.$api
            .createInquiry(para)
            .then((res) => {
              if (res.data.meta.success) {
                this.hanldeLook();
              } else {
                this.$message({
                  message: res.data.meta.message,
                  type: "error",
                });
              }
              this.waitLoading = false;
            })
            .catch((err) => {
              this.waitLoading = false;
              this.$message({
                message: err.data.message,
                type: "error",
              });
            });
        }
      }
    },
    // 按钮不同功能
    tableBtn(e) {
      this.recordRow = e.row;
      this.tabIndex = this.buttonActive;
      this.hanldeLook(e);
    },
    hanldeLook(e) {
      this.dialogVisibleLook = true;
      this.dialogVisible = false;
      this.waitLoading = true;
      let para = {
        recordId: this.recordRow.id,
      };
      this.$api
        .inquiryDetails(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.bidInquiryDetails = res.data.data.bidInquiryDetails;
            this.bidRecord = res.data.data.bidRecord;
            this.dateDifference = res.data.data.dateDifference;
            this.clearCountDown(); // 开启倒计时之前先清空
            this.countDown();
          } else {
            this.$message({
              message: res.data.meta.message,
              type: "error",
            });
          }
          this.waitLoading = false;
        })
        .catch((err) => {
          this.waitLoading = false;
          this.$message({
            message: err.data.message,
            type: "error",
          });
        });
    },
    // 生成pdf
    createPdf() {
      let para = {
        recordId: this.recordRow.id,
      };
      this.$api
        .createPdf(para)
        .then((res) => {
          if (res.data.meta.success) {
            console.log(res.data);
            this.$message({
              message: "生成pdf成功!",
              type: "success",
            });
            this.hanldeLook();
          } else {
            this.$message({
              message: res.data.meta.message,
              type: "error",
            });
          }
          this.waitLoading = false;
        })
        .catch((err) => {
          this.waitLoading = false;
          this.$message({
            message: err.data.message,
            type: "error",
          });
        });
    },
    goSign() {
      let para = {
        recordId: this.recordRow.id,
      };
      this.$api
        .signInfo(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.pdfInfo = res.data.data;
            const host = "http://" + location.host;
            const serachUrl =
              "?type=" +
              this.pdfInfo.caType +
              "&isTbr=1&blockId=" +
              this.pdfInfo.sectionId +
              `&pdfUrl=${host}/api/v2/kb/upload/getInquiryPdf/` +
              this.recordRow.id +
              `&uploadUrl=${host}/api/v2/kb/upload/inquirySignature/` +
              this.recordRow.id +
              "&systemType=lanxi" +
              "&url=https://ca.zhaotx.cn/test";
            window.open(`/qZ?${serachUrl}`, "_blank");
            this.isShowSureQzDialog = true;
          } else {
            this.$message({
              message: res.data.meta.message,
              type: "error",
            });
          }
          this.waitLoading = false;
        })
        .catch((err) => {
          this.waitLoading = false;
          this.$message({
            message: err.data.message,
            type: "error",
          });
        });
    },
    back() {
      const tabIndex = this.tabIndex || 0;
      this.buttonActive = tabIndex;
      if (!this.dialogVisibleSign) {
        this.dialogVisibleLook = false;
        this.dialogVisible = true;
        this.openList();
      }
    },
    backLook(num) {
      if (num) {
        this.dialogVisibleSign = false;
        this.back();
      } else {
        this.dialogVisibleSign = false;
        this.dialogVisibleLook = true;
        this.hanldeLook();
      }
    },
    // 倒计时
    countDown() {
      // console.log('this.dateDifference', this.dateDifference)
      if (this.dateDifference <= 0) return;
      this.clearCountDown();
      this.timeInterval = setTimeout(() => {
        // 倒计时大于 1 s 且显示时
        if (this.dateDifference >= 0 && this.dialogVisibleLook) {
          this.dateDifference -= 1000; // -1s
          this.countDown();
        } else {
          this.clearCountDown();
        }
      }, 1000);
    },
    iframeLoad() {
      window.addEventListener(
        "message",
        (event) => {
          if (event.data.saveSign) {
            //签章完成保存签章，后续逻辑，需要前端传的参数，blockId，caNo等
            this.backLook(1);
          }
        },
        false
      );
    },
    clearCountDown() {
      if (this.timeInterval) clearTimeout(this.timeInterval);
      this.timeInterval = null;
    },
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },

    // 同步项目状态到交易平台（进入项目前置流程）
    async syncProjectState(project) {
      try {
        const { bdId } = project;
        await this.$api.syncProjectState({ bdId });
      } catch(err) {
        console.error('syncProjectState fail', err);
      }
    },
  },
  mounted() {
    if (localStorage.getItem("searchObj")) {
      let obj = JSON.parse(localStorage.getItem("searchObj"));
      this.xmlx = obj.xmlx;
      this.currentPage = obj.currentPage;
      this.searchText = obj.searchText;
    }
    this.getReplyNum();
    this.getData();
  },
};
</script>
<style lang="less" scope>
.button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  .sure-qz {
    width: 98px;
    height: 40px;
    background-color: #0060b2;
    border-color: #0060b2;
    color: #fff;
    margin-top: 20px;
  }
}
.kbxmList {
  position: relative;
  height: calc(~"100% - 80px");
  background: url("../assets/images/lhBg.png") no-repeat center center;
  background-size: cover;
  overflow-y: auto;
  padding-bottom: 20px;
  min-width: 1240px;
  > div {
    width: 1200px;
    margin: 0 auto;
    .searchBox {
      margin: 35px 0;
      text-align: right;
      button {
        width: 250px;
        height: 60px;
        line-height: 60px;
        padding: 0;
        margin: 0 10px;
        font-size: 20px;
        color: @base-color;
        background: #fff;
      }
      button.active {
        background: @base-color;
        color: #fff;
        font-weight: bold;
      }
      .el-button--default {
        color: @base-color;
      }
      > .el-input {
        width: 300px;
        height: 38px;
        line-height: 38px;
        position: relative;
        top: 8px;
        margin-left: 10px;
        input {
          height: 38px;
          border-color: #fff;
          line-height: 38px;
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
        }
        input::-webkit-input-placeholder {
          color: #fff;
        }
        .el-icon-search:before {
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
    .xmLists {
      li {
        height: 110px;
        margin-bottom: 20px;
        background: #fff;
        border-radius: 3px;
        padding-left: 33px;
        position: relative;
        overflow: hidden;
        box-shadow: 0 4px 10px rgba(00, 00, 00, 0.2);
        cursor: pointer;
        > .lf {
          width: 1140px;
          h3 {
            font-size: 18px;
            color: #333;
            margin: 30px 0 15px 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          p {
            color: #999;
            font-size: 14px;
            span {
              color: #666;
              font-weight: bold;
              font-size: 18px;
              margin: 0 120px 0 10px;
              font-family: Arial;
            }
          }
        }
      }
      li.active {
        background: #fff url("../assets/images/active.png") no-repeat top right;
      }
      li.active:hover {
        background: #f5f0f1 url("../assets/images/active.png") no-repeat top
          right;
      }
      li.wait {
        background: #fff url("../assets/images/wait.png") no-repeat top right;
      }
      li.wait:hover {
        background: #f5f0f1 url("../assets/images/wait.png") no-repeat top right;
      }
      li.over {
        h3 {
          color: #999;
        }
        p {
          color: #ccc;
          span {
            color: #999;
          }
        }
        background: #fff url("../assets/images/over.png") no-repeat top right;
      }
      li.over:hover {
        background: #f5f0f1 url("../assets/images/over.png") no-repeat top right;
      }
      li.zz {
        background: #fff url("../assets/images/zz.png") no-repeat top right;
      }
      li.zz:hover {
        background: #f5f0f1 url("../assets/images/zz.png") no-repeat top right;
      }
    }
    .noList {
      font-size: 18px;
      color: #fff;
      text-align: center;
      padding: 100px 0;
    }
  }
  .page .lf {
    color: #fff;
  }
}
</style>
<style lang="scss" scoped>
::v-deep .dialogVisible > div {
  ::-webkit-scrollbar {
    width: 5px; /* 纵向滚动条 宽度 */
    height: 15px; /* 横向滚动条 高度 */
    background: none; /* 整体背景 */
    border-radius: 10px; /* 整体 圆角 */
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(16, 129, 194);
    min-height: 50px;
    min-width: 50px;
    border-radius: 10px;
  }
  background: rgba(18, 48, 86, 0.8);
  border: 1px solid #1065c2;
  box-shadow: inset 0 0 49px rgba(16, 101, 194, 0.9);
  border-radius: 3px;
  min-width: 680px;
  .el-dialog__header {
    border-bottom: none;
    padding: 0;
  }
  p {
    font-weight: bold;
    width: 100%;
    cursor: pointer;
    button {
      padding: 6px 30px;
      color: #fff;
      background: rgba(16, 101, 194, 0.5);
      margin-right: 10px;
      span {
        display: inline-block;
        transform: skewX(20deg);
      }
    }
    .buttonChecked {
      background: #1065c2;
    }
  }
  .xie {
    transform: skewX(-20deg);
    width: 800px;
  }
}
::v-deep .table {
  margin: 20px 0;
  .el-table,
  .el-table th,
  td,
  tr .el-table--group::after,
  .el-table--border::after,
  .el-table::before,
  .el-table__header colgroup,
  .has-gutter tr,
  .el-table__header-wrapper,
  .el-table__row {
    background: none !important;
  }
  .el-table th > .cell,
  .el-table__row {
    color: #fff;
  }
  .el-table tr,
  td,
  th,
  .el-table--group,
  .el-table--border,
  .el-table th.is-leaf,
  .el-table td {
    border: 1px solid #1169a2;
  }
  b {
    font-weight: normal;
    color: red;
    display: block;
  }
  .el-pagination {
    margin-top: 20px;
  }
}
.bg-info {
  border-collapse: collapse;
  width: 100%;
  color: #fff;
  > tr {
    > td {
      max-width: 1px;
      padding: 12px 10px;
      line-height: 24px;
      border: 1px solid #ccc;
      width: 35%;
      &:nth-child(odd) {
        width: 15%;
        background: none;
        text-align: left;
      }
      &:nth-child(even) {
        text-align: left;
      }
    }
  }
}
.bg-info {
  tr {
    .td_content_box {
      background-color: #fff !important;
      table {
        border-collapse: collapse;
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        td,
        th {
          border-bottom: 1px solid #ccc;
          border-right: 1px solid #ccc;
          padding: 3px 5px;
          min-height: 30px;
        }
        th {
          border-bottom: 2px solid #ccc;
          text-align: center;
          background-color: #f1f1f1;
        }
      }
      div {
        height: 300px;
        overflow: auto;
      }
    }
    &:last-child {
      td:nth-child(odd) {
        text-align: left;
      }
    }
  }
}
.time {
  text-align: right;
}
.el-button,
.el-button:hover,
.el-button:active,
.el-button:focus {
  color: #fff !important;
  background: none;
  border: 1px solid #ffffff !important;
}
.dialogTitlt {
  text-align: center;
  font-size: 18px;
  line-height: 40px;
  color: #fff;
  padding-bottom: 20px;
}
.time i {
  margin: 0 20px;
}
#replyContent {
  background: none;
  color: #fff;
  text-indent: 2em;
  min-height: 150px;
}
.yhf {
  width: 50px;
  height: 50px;
  background: url("../assets/images/yhf.png") no-repeat center;
  background-size: 100%;
  float: right;
}
.cswhf {
  width: 55px;
  height: 50px;
  background: url("../assets/images/cswhf.png") no-repeat center;
  background-size: 100%;
  float: right;
}
.stauts {
  color: #d70a30;
  font-size: 14px;
  text-align: right;
  margin-right: 20px;
}
.djs {
  font-weight: bold;
  font-size: 18px;
  margin-left: 10px;
}
</style>
